import stringify from 'fast-safe-stringify'

import { SomeEntity } from '~/clients/api-guards'

import { DiEntityKey, useStore } from '../store'

export type Awaited<T> = T extends PromiseLike<infer U> ? Awaited<U> : T

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export type AsyncFn = (...args: any[]) => Promise<any>

export function getErrorMessage<T extends AsyncFn>(call: T, args: Parameters<T>, response: unknown): string
export function getErrorMessage(call: string, args: unknown, response: unknown): string
export function getErrorMessage(call: AsyncFn | string, args: unknown, response: unknown): string {
    return `Fetching '${typeof call === 'string' ? call : call.name}' failed with args ${stringify(args)}. Response: ${stringify(response)}`
}

/**
 * Resolve an entity by either numeric id or string uuid, using the matching
 * index maintained by diSlice. Returns the stored entity (or undefined) and
 * the canonical numeric id that the store's mutation actions expect.
 */
export function lookupEntity(key: DiEntityKey, idOrUuid: number | string): { entity: SomeEntity | undefined; numericId: number | undefined } {
    const table = useStore.getState().di.entities[key]
    if (typeof idOrUuid === 'string') {
        const entity = table.byUuid[idOrUuid] as SomeEntity | undefined
        return { entity, numericId: entity?.id }
    }
    const entity = table.byId[idOrUuid] as SomeEntity | undefined
    return { entity, numericId: idOrUuid }
}
